export const visit = (vm, at) => {
at({ "fr": { "conversations-message-history": { "status": { "closed": "Ce fil a \xE9t\xE9 ferm\xE9 le {{ dateString }}", "restore": "Restaurer ce message", "publishing": { "UNPUBLISHED": "Envoi en cours...", "PUBLISH_FAILED": "Non remis. Cliquez pour r\xE9essayer." } } } } });
};